module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-3-a4c3e73bcabc1406f48c49a7fffcfd53.jpg";